import { ChangeEvent, Dispatch, FormEvent, ReactElement, SetStateAction } from 'react';
import { Select, InputError, Form, FormRow, TextInput, Button } from '@op/opds.opux';
import { IconDelete } from '@op/opds.opux-icons/action';
import { useMessage } from '@messageformat/react';
import { getMsgValues } from '../../utils';

interface Props {
  dreams: {
    dream: string;
    cost: number;
    id: number;
  }[];
  setDreams: Dispatch<
    SetStateAction<
      {
        dream: string;
        cost: number;
        id: number;
      }[]
    >
  >;
  index: number;
}

const generateOptions = (
  dreamsArray: string[],
  costArray: number[],
): { dream: string; cost: number }[] => {
  return dreamsArray.map((dream, index) => {
    return { dream, cost: costArray[index] };
  });
};

const DreamInput = (props: Props): ReactElement => {
  const { dreams, setDreams, index } = props;
  // Get values of this component from state
  const currentObject = dreams[index];
  const labels = getMsgValues(useMessage('course4.question2.labels'));
  const defaultOption = useMessage('select_default_option');
  const dreamArray = getMsgValues(useMessage('course4.question2.dreams'));
  const costs = [
    1500, 1000, 1000, 500, 5000, 30000, 1500, 300, 20000, 15000, 50000, 100000, 0,
  ];

  const options = generateOptions(dreamArray, costs);

  const getCostOfDream = (dream: string): number => {
    const thisObject = options.find((element) => {
      return element.dream === dream;
    });
    return thisObject !== undefined ? thisObject.cost : 0;
  };

  const cleanNumberString = (amount: number): string => {
    const amountString = amount.toString();
    const cleanNumber = amountString.replace(/^0+(\d+)/, '$1');
    return cleanNumber;
  };

  const handleChange = (
    event: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>,
  ): void => {
    const newEntry =
      event.target.tagName === 'SELECT'
        ? { dream: event.target.value, cost: getCostOfDream(event.target.value) }
        : { cost: Number(event.target.value) };

    const newObject = { ...currentObject, ...newEntry };
    const copy = [...dreams];
    copy.splice(index, 1, newObject);
    setDreams(copy);
  };

  const deleteDream = (): void => {
    const copy = [...dreams];
    copy.splice(index, 1);
    setDreams(copy);
  };

  const inputHasValueButSelectIsEmpty = (): boolean => {
    if (currentObject.cost !== 0 && currentObject.dream === 'default') {
      return true;
    }
    return false;
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
  };

  return (
    <div className="investoracademy-planner-input-tile">
      <Form stacked spacing="small" style={{ width: '100%' }} onSubmit={handleSubmit}>
        <FormRow label={labels[0]} style={{ marginTop: '0px' }}>
          <Select
            defaultValue="default"
            onChange={handleChange}
            invalid={inputHasValueButSelectIsEmpty()}
          >
            <option value="default" disabled label={defaultOption} />
            {options.map((element) => {
              return (
                <option key={`option ${element.dream}`} value={element.dream}>
                  {element.dream}
                </option>
              );
            })}
          </Select>
          {inputHasValueButSelectIsEmpty() && (
            <InputError error={labels[1]} id="error-message" />
          )}
        </FormRow>
        {currentObject.dream === dreamArray[12] && (
          <FormRow label={labels[2]}>
            <TextInput placeholder={labels[3]} />
          </FormRow>
        )}
        <FormRow label={labels[4]}>
          <TextInput
            amount
            unit="€"
            onChange={handleChange}
            value={cleanNumberString(currentObject.cost)}
            aria-describedby="error-message"
          />
        </FormRow>
      </Form>
      {Number(index) !== 0 && (
        <Button minified icon={IconDelete} iconLabel={labels[5]} onClick={deleteDream} />
      )}
    </div>
  );
};

export default DreamInput;
